<template lang="pug">
  .c-bananas-widget(v-if='!noResults && packageLists' v-scroll="scrollVisible")
    .c-bananas-widget__loop(v-for='packageList in packageResults' :class="{'c-bananas-widget--fade': !packageOfferLoading}" v-show='!packageOfferLoading')
      .c-offercard__wrapper(v-for='(offer, index) in packageList.data.ranks[0].items' :class="['js-offercard--' + index]")
        .c-offercard
          .c-offercard__image(:style="{backgroundImage: 'url('+ packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].image.lead +')'}" @click='showModal(packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].giata_id, packageList.data.packages[offer].pricings[0].partner.id)')
          .c-offercard__info
            .c-offercard__price
              img.c-offercard__provider-image(v-if="locale === 'de-DE' || locale === 'de-AT' || locale === 'de-CH'" :src="['https://cluster2.images.traveltainment.eu/images/content/va_logos/cp/small/' + packageList.data.packages[offer].pricings[0].partner.id + '.gif']")
              img.c-offercard__provider-image(v-else :src="['https://s3.eu-central-1.amazonaws.com/tremo-web-assets/provider/packages/' + packageList.data.packages[offer].pricings[0].partner.id + '.png']")
              span.c-offercard__price-prefix {{ $t('text.pricefrom') }}
              span.c-offercard__price-currency(v-if="packageList.data.packages[offer].info.price.currency !== 'EUR'") {{$t('text.currency.' + packageList.data.packages[offer].info.price.currency)}}
              span.c-offercard__price-value {{ packageList.data.packages[offer].info.price.amount }}
              span.c-offercard__price-currency(v-if="packageList.data.packages[offer].info.price.currency === 'EUR'") {{$t('text.currency.' + packageList.data.packages[offer].info.price.currency)}}
              span.c-offercard__price-extended p.P.
            .c-offercard__category
              img.c-offercard__category-icon(src='https://s3.eu-central-1.amazonaws.com/tremo-web-assets/icons/holidays.svg')
              .c-offercard__headline
                | {{ packageList.data.packages[offer].info.duration }}&nbsp;
                span(v-if='packageList.data.packages[offer].info.duration > 1') {{ $t("text.day.other") }}&nbsp;
                span(v-else) {{ $t("text.day.one") }}&nbsp;
                span {{ $t("text.package.atdestination") }} {{ packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].location.city }} {{ $t("headline.package.fromorigin") }}&nbsp;
                span.c-offercard__action-link(v-if='editable' @click='toggleAutocomplete') {{ packageList.data.dict.airports[packageList.data.packages[offer].flights[0].orig].name }}
                span(v-else) {{ packageList.data.dict.airports[packageList.data.packages[offer].flights[0].orig].name }}
            .c-offercard__hotel
              strong.c-offercard__hotelname {{ packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].name }}
              span.c-offercard__hotelcategory
                span.c-offercard__hotel-category-point(v-for='point in packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].category[0]')
                span.c-offercard__hotel-category-point--half(v-if='packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].category[1]')
                  span.c-offercard__hotel-category-point--half-left
                  span.c-offercard__hotel-category-point--half-right
            .c-offercard__meta.c-offercard__hotel-details
              .c-offercard__hotel-details-properties
                .c-offercard__hotel-board-type
                  <svg class="c-offercard__hotel-board-type-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" d="M0 0h24v24H0V0z"/>
                    <path class="c-offercard__hotel-board-type-icon--path" d="M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4zm-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2v7z"/>
                  </svg>
                  span(v-if='packageList.data.dict.accommodationboards[packageList.data.packages[offer].accommodations[0].rooms[0].board].name') {{ packageList.data.dict.accommodationboards[packageList.data.packages[offer].accommodations[0].rooms[0].board].name }}
                  span(v-else) {{ packageList.data.dict.accommodationboards[packageList.data.packages[offer].accommodations[0].rooms[0].board] }}
                .c-offercard__hotel-room-type
                  <svg class="c-offercard__hotel-room-type-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" d="M0 0h24v24H0V0z"/>
                    <path class="c-offercard__hotel-room-type-icon--path" d="M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"/>
                  </svg>
                  | {{ packageList.data.packages[offer].accommodations[0].rooms[0].display }}
              .c-offercard__hotel-details-rating
                .c-offercard__meta.c-offercard__hotel-rating(v-if='packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].rating.overall')
                  .c-offercard__hotel-rating-wrapper
                    span.c-offercard__hotel-rating-count {{ packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].rating.overall.count }} {{ $t("text.reviews") }}
                    .c-offercard__hotel-rating-container
                      <svg class="c-offercard__hotel-rating-squares">
                          <rect x="0" y="0" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                          <rect x="12" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                          <rect x="24" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                          <rect x="36" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                          <rect x="48" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                          <rect x="60" width="11" height="11" style="fill:#fff;fill-opacity:0;stroke-width:1;stroke:#fff" />
                      </svg>
                      <progress class="c-offercard__hotel-rating-progress" min="0" max="100" :value="packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].rating.overall.value + 2"></progress>
                    span.c-offercard__hotel-rating-total {{ packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].rating.overall.value | calculateRating }} / 6.0
                  span.c-offercard__hotel-rating-recommendation(:class="{'c-offercard__hotel-rating-recommendation--red': packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].rating.recommendation.value < 60, 'c-offercard__hotel-rating-recommendation--yellow': packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].rating.recommendation.value >= 60, 'c-offercard__hotel-rating-recommendation--green': packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].rating.recommendation.value >= 80}") {{ packageList.data.accommodations[packageList.data.packages[offer].accommodations[0].id].rating.recommendation.value | roundRecommendation }}%
            hr.c-offercard-horizontal-line
            .c-offercard__meta
              .c-offercard__flight-block
                .c-offercard__flight-block-item.c-offercard__flight-time
                  span {{ packageList.data.packages[offer].flights[0].dep.time }}
                  br
                  span {{ [packageList.data.packages[offer].flights[0].dep.date, locale] | formatFlightDate }}
                .c-offercard__flight-block-item.c-offercard__flight-airport {{ packageList.data.dict.airports[packageList.data.packages[offer].flights[0].orig].iata }}
                .c-offercard__flight-block-item--small
                  img(src="https://s3.eu-central-1.amazonaws.com/tremo-web-assets/icons/flight.svg")
                .c-offercard__flight-block-item.c-offercard__flight-airport {{ packageList.data.dict.airports[packageList.data.packages[offer].flights[0].dest].iata }}
                .c-offercard__flight-block-item.c-offercard__flight-dates
                  span {{ packageList.data.packages[offer].flights[0].arr.time}}
                  br
                  span {{ [packageList.data.packages[offer].flights[0].arr.date, locale] | formatFlightDate }}
              .c-offercard__flight-block
                .c-offercard__flight-block-item.c-offercard__flight-time
                  span {{ packageList.data.packages[offer].flights[1].dep.time }}
                  br
                  span {{ [packageList.data.packages[offer].flights[1].dep.date, locale] | formatFlightDate }}
                .c-offercard__flight-block-item.c-offercard__flight-airport {{ packageList.data.dict.airports[packageList.data.packages[offer].flights[1].orig].iata }}
                .c-offercard__flight-block-item--small.c-offercard__flight-icon--reverse
                  img(src="https://s3.eu-central-1.amazonaws.com/tremo-web-assets/icons/flight.svg")
                .c-offercard__flight-block-item.c-offercard__flight-airport {{ packageList.data.dict.airports[packageList.data.packages[offer].flights[1].dest].iata }}
                .c-offercard__flight-block-item.c-offercard__flight-dates
                  span {{ packageList.data.packages[offer].flights[1].arr.time}}
                  br
                  span {{ [packageList.data.packages[offer].flights[1].arr.date, locale] | formatFlightDate }}
          .c-offercard__button
            form(action="https://rdr.holidaypirates.group/v1/link" target="_blank" method="post")
              input(type="hidden" name="config[redirect]" value="true")
              input(type="hidden" name="data[url][encoding]" value="base64_url")
              input(type="hidden" name="data[url][url]" :value="base64EncodeUnicode(packageList.data.packages[offer].pricings[0].link)")
              input.c-btn.c-btn--function.c-offercard__button-link(:value='$t("button.package")' type="submit" @click='clickOut')
        .c-offercard__autocomplete(:class="{'c-offercard__autocomplete-open': autoCompleteOpen}" v-show='!packageOfferLoading')
          span.c-offercard__autocomplete-close
          .c-offercard__autocomplete--group
            label.c-offercard__autocomplete--label {{ $t('label.changeorigin') }}
            Multiselect(
              v-model="selectedAirports",
              :options="packageDestinations",
              :multiple="multiple",
              :searchable="searchable",
              @search-change="searchForPackageDestinations",
              @select="onSelect",
              :placeholder="$t('placeholder.changeorigin')",
              :custom-label="customLabel",
              :show-labels="false"
            )
              span(slot="noResult").
                {{ $t('text.changeorigin.noresultsautocomplete') }}
              span(slot="noOptions").
                {{ $t('text.changeorigin.mincharacters') }}
              template(slot="singleLabel", slot-scope="props")
                span.option__title {{ props.option.name }} ({{ props.option.values.iata }})
              template(slot="option", slot-scope="props")
                span.option__title {{ props.option.name }} ({{ props.option.values.iata }})
          span.c-btn.c-btn--function.c-offercard__success-btn(@click='updatePackageOffer') {{ $t('button.changeorigin') }}
    .c-hightlights--loading(v-show='packageOfferLoading')
      span.c-hightlights--loading__point
      span.c-hightlights--loading__point
      span.c-hightlights--loading__point
  .c-bananas-widget__empty(v-else)
    .c-offercard__no-results
      p.c-offercard__no-results-headline {{ $t('text.changeorigin.noresults') }}
      img(src='https://s3.eu-central-1.amazonaws.com/tremo-web-assets/img/no-results.png')
      p.c-offercard__no-results-text {{ $t('text.changeorigin.alternative') }}
      ul.c-offercard__no-results-alternative-list(v-if="locale === 'de-DE'")
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Frankfurt/Main", values: {iata: "FRA"}})') Frankfurt/Main
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Berlin (alle Flughäfen)", values: { iata: "BER"}})') Berlin (alle Flughäfen)
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "München", values: { iata: "MUC"}})') München
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Düsseldorf", values: { iata: "DUS"}})') Düsseldorf
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Hamburg", values: { iata: "HAM"}})') Hamburg
      ul.c-offercard__no-results-alternative-list(v-else)
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Seattle/Tacoma Intl. Airport", values: {iata: "SEA"}})') Seattle/Tacoma Intl. Airport
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "San Francisco Intl. Airport", values: { iata: "SFO"}})') San Francisco Intl. Airport
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Los Angelas Intl. Airport", values: { iata: "LAX"}})') Los Angelas Intl. Airport
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Phoenix Sky Harbor Intl. Airport", values: { iata: "PHX"}})') Phoenix Sky Harbor Intl. Airport
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Denver Intl. Airport", values: { iata: "DEN"}})') Denver Intl. Airport
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Miami Intl. Airport", values: { iata: "MIA"}})') Miami Intl. Airport
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "New York (All Airports)", values: { iata: "NYC"}})') New York (All Airports)
        li.c-offercard__no-results-alternative-list-item(@click='getFallback({name: "Chicago (All Airports)", values: { iata: "CHI"}})') Chicago (All Airports)
</template>

<script>
import fecha from 'fecha'
import dbActions from '../api/dbactions'
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import packageSchema from '@/utils/schemas/package.js'
import packageSetup from '@/settings/packageSetup.js'

export default {
  name: 'PackageTeaser',
  props: ['packageLists', 'dateFormat', 'timeFormat', 'editable'],
  data() {
    return {
      localMessages: this.$i18n.messages[this.$store.getters.getLocale],
      autoCompleteOpen: false,
      packageOfferLoading: false,
      multiple: false,
      searchable: true,
      selectedAirports: [],
      packageDestinations: [],
      originAirport: '',
      userSelection: [],
      packageResults: this.packageLists,
      noResults: false,
      locale: this.$store.getters.getLocale,
      tracked: false,
      trackHostNames: this.$store.getters.getTrackingHostNames,
      trackingAllowed: true
    }
  },
  components: {
    Multiselect
  },
  created() {
    if (this.packageLists !== null && this.packageLists.length > 0) {
      this.reformatHotelCategory()
      let iata = this.packageResults[0].data.packages[
        this.packageResults[0].data.ranks[0].items[0]
      ].flights[0].orig
      this.originAirport = this.packageResults[0].data.dict.airports[iata].name
      this.selectedAirports = [
        {
          name: this.originAirport,
          values: {
            iata: iata
          }
        }
      ]
      this.userSelection = [iata]
    }
  },
  filters: {
    calculateRating(value) {
      let rating = (value * 6) / 100
      return rating.toFixed(1)
    },
    roundRecommendation(value) {
      return value.toFixed(0)
    },
    formatTime(rawDateTime) {
      if (rawDateTime[1] !== undefined) {
        return fecha.format(
          fecha.parse(
            rawDateTime[0] + ' ' + rawDateTime[1],
            'YYYY-MM-DD HH:mm'
          ),
          rawDateTime[2]
        )
      } else {
        return fecha.format(
          fecha.parse(rawDateTime[0], 'YYYY-MM-DD'),
          rawDateTime[2]
        )
      }
    },
    formatFlightDate(dateArray) {
      if (dateArray[1] === 'en-US') {
        return fecha.format(new Date(dateArray[0]), 'MM/DD/YYYY')
      }
      return fecha.format(new Date(dateArray[0]), 'DD.MM.YYYY')
    }
  },
  mounted() {
    this.scrollVisible()
  },
  methods: {
    reformatHotelCategory() {
      this.packageLists.forEach(packageList => {
        for (const key of Object.keys(packageList.data.accommodations)) {
          for (const keyi of Object.keys(
            packageList.data.accommodations[key]
          )) {
            if (keyi === 'category') {
              let newCategory = packageList.data.accommodations[key][keyi] + ''
              newCategory = newCategory.split('.')
              let points = []
              for (let i = 0; i < parseInt(newCategory[0]); i++) {
                points.push('1')
              }
              if (newCategory.length > 1) {
                newCategory = [points, true]
              } else {
                newCategory = [points, false]
              }
              packageList.data.accommodations[key][keyi] = newCategory
            }
          }
        }
      })
    },
    clickOut() {
      // Track clickOut
      let actionData = {
        url:
          window.location.protocol +
          '//' +
          window.location.host +
          '/' +
          window.location.pathname,
        language: this.$store.getters.getLocale,
        type: 'clickOut',
        vertical: 'package',
        unique: this.$store.getters.getUniqueClickOut
      }
      this.$store.dispatch('updateUniqueClickOut')
      if (this.$store.getters.getTrackingIsAllowed) {
        dbActions.trackAction(actionData, this)
      }
      this.trackClick()
    },
    toggleAutocomplete() {
      this.autoCompleteOpen = !this.autoCompleteOpen
    },
    searchForPackageDestinations(query) {
      let vm = this
      if (query.length > 1) {
        axios
          .get(
            'https://autocomplete.holidaypirates.group/v1/suggest?data[term]=' +
              query +
              '&data[filters][types]=&config[target]=orig&config[type]=ibe&config[source]=123&config[language]=' +
              this.$store.getters.getLocaleShort
          )
          .then(function(response) {
            vm.packageDestinations = []
            response.data.data.results.forEach(object => {
              vm.packageDestinations.push(object)
            })
          })
      }
    },
    onSelect(option, id) {
      this.originAirport = option.name
      this.userSelection = [option.values.iata]
    },
    updatePackageOffer() {
      let vm = this
      vm.autoCompleteOpen = !vm.autoCompleteOpen
      // Set offer to loading
      vm.packageOfferLoading = true
      // Search for offer
      const packageConfig = this.setPackageProvider()
      let packageSearchObject = packageSetup
      packageSearchObject.language = this.$store.getters.getLocaleShort
      packageSearchObject.airport = vm.userSelection
      let packageData = packageSchema.setPackageSchema(packageSearchObject)
      axios
        .post(packageConfig.searchEndpoint, packageData, {
          headers: ''
        })
        .then(function(response) {
          vm.packageResults = []
          if (response.data.config.count.total > 0) {
            vm.packageResults.push(response.data)
          } else {
            vm.noResults = true
          }
        })
        .then(function() {
          vm.packageOfferLoading = false
        })
    },
    customLabel({ name, values }) {
      return `${name} (${values.iata})`
    },
    getFallback(airport) {
      let vm = this
      vm.noResults = false
      // Set offer to loading
      vm.packageOfferLoading = true
      // Search for offer
      let configData = window.bananasHighlightsConfigData[0]
      const packageConfig = this.setPackageProvider()
      configData.language = this.$store.getters.getLocaleShort
      configData.airport = [airport.values.iata]
      let packageData = packageSchema.setPackageSchema(configData)
      axios
        .post(packageConfig.searchEndpoint, packageData, {
          headers: ''
        })
        .then(function(response) {
          if (response.data.config.count.total > 0) {
            vm.selectedAirports = [airport]
            vm.packageResults.push(response.data)
          }
        })
        .then(function() {
          vm.packageOfferLoading = false
        })
    },
    setPackageProvider() {
      let configProvider = {}
      if (this.$store.getters.getLocale === 'en-US') {
        configProvider.autosuggestEndpoint =
          'https://tremo-tmf.holidaypirates.group/v1.1/suggest'
        configProvider.searchEndpoint =
          'https://tremo-tmf.holidaypirates.group/v1.1/search'
        configProvider.data = {
          filters: {
            types: ''
          }
        }
        configProvider.config = {
          type: 'peakwork',
          target: 'dest'
        }
      } else {
        // default de-DE config
        configProvider.autosuggestEndpoint =
          'https://autocomplete.holidaypirates.group/v1/suggest'
        configProvider.searchEndpoint =
          'https://tm.holidaypirates.group/v1/search'
        configProvider.data = {
          filters: {
            types: 'places'
          }
        }
        configProvider.config = {
          type: 'ibe',
          target: 'dest'
        }
      }
      return configProvider
    },
    checkTrackingAllowed() {
      // Test Cookie with tracking rules
      // this.$cookies.set('tarteaucitron', '!snowplow=false!doubleclick=true!hotjar=true!googletagmanager=true!trustpilot=true!facebook=true!instagram=true!pinterest=true!twitter=true!youtube=true')
      if (this.$cookies.isKey('tarteaucitron')) {
        let trackingAllowed = this.$cookies.get('tarteaucitron')
        trackingAllowed = trackingAllowed.split('!')
        trackingAllowed = trackingAllowed[1].split('=')
        if (trackingAllowed[1] !== 'true') {
          this.trackingAllowed = false
          // Set store flag to false for tracking is allowed
          this.$store.dispatch('updateTrackingIsAllowed')
        } else {
          if (!this.trackHostNames.includes(window.location.hostname)) {
            this.trackingAllowed = false
            // Set store flag to false for tracking is allowed
            this.$store.dispatch('updateTrackingIsAllowed')
          }
        }
      }
      // Everytime true on localhost for development
      if (window.location.hostname === 'localhost') {
        this.trackingAllowed = false
        this.$store.dispatch('updateTrackingIsAllowed')
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.toString() !== '') {
          if (urlParams.has('bn-track')) {
            if (urlParams.get('bn-track') === '1') {
              this.trackingAllowed = true
              this.$store.dispatch('setTrackingIsAllowed')
            }
          }
        }
      }
    },
    scrollVisible() {
      if (this.trackingAllowed && !this.tracked) {
        this.checkOfferVisible()
      }
    },
    getBoundingClientRect(element) {
      const {
        top,
        right,
        bottom,
        left,
        width,
        height,
        x,
        y
      } = element.getBoundingClientRect()
      return { top, right, bottom, left, width, height, x, y }
    },
    checkOfferVisible() {
      const pageCoordinates = this.getBoundingClientRect(this.$el.children[0])
      if (
        pageCoordinates.top >= 0 &&
        pageCoordinates.left >= 0 &&
        pageCoordinates.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        pageCoordinates.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      ) {
        let pageType = 'undefined'
        let pagePostId = 'undefined'
        if (window.dataLayer.length > 0) {
          if (window.dataLayer[0].hasOwnProperty('pageType')) {
            pageType = window.dataLayer[0].pageType
          }
          if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
            pagePostId = window.dataLayer[0].pagePostId
          }
        }
        try {
          const offer = this.packageLists[0].data
          const offerId = offer.ranks[0].items[0]
          const hotelData =
            offer.accommodations[offer.packages[offerId].accommodations[0].id]
          let creativeFlightData = 'undefined'
          if (offer.packages[offerId].flights.length > 0) {
            creativeFlightData =
              offer.packages[offerId].flights[0].orig +
              '-' +
              offer.packages[offerId].flights[0].dest +
              ':' +
              offer.packages[offerId].flights[1].orig +
              '-' +
              offer.packages[offerId].flights[1].dest
          }
          window.dataLayer.push({
            event: 'promoView',
            category: 'dealPromotion',
            action: 'impression',
            label:
              'automated' +
              '|' +
              pagePostId +
              '|' +
              this.packageLists[0].config.adapter +
              '|package|' +
              offerId, // for example 'unifiedSearch|flight'
            ecommerce: {
              promoView: {
                promotions: [
                  {
                    id: offerId,
                    name:
                      'automated|' +
                      this.packageLists[0].config.adapter +
                      '|' +
                      pageType +
                      '|package|' +
                      hotelData.name, // for example 'unifiedSearch|flight'
                    creative:
                      hotelData.location.continent +
                      ':' +
                      hotelData.location.country +
                      ':' +
                      hotelData.location.city +
                      '|' +
                      creativeFlightData,
                    position: undefined
                  }
                ]
              }
            }
          })
        } catch (err) {}
        this.tracked = true
      }
    },
    base64EncodeUnicode(str) {
      // First we escape the string using encodeURIComponent to get the UTF-8 encoding of the characters,
      // then we convert the percent encodings into raw bytes, and finally feed it to btoa() function.
      const utf8Bytes = encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function(match, p1) {
          return String.fromCharCode('0x' + p1)
        }
      )

      return btoa(utf8Bytes)
    },
    trackClick() {
      window.dataLayer = window.dataLayer || []
      let pageType = 'undefined'
      let pagePostId = 'undefined'
      if (window.dataLayer.length > 0) {
        if (window.dataLayer[0].hasOwnProperty('pageType')) {
          pageType = window.dataLayer[0].pageType
        }
        if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
          pagePostId = window.dataLayer[0].pagePostId
        }
      }
      try {
        const offer = this.packageLists[0].data
        const offerId = offer.ranks[0].items[0]
        const hotelData =
          offer.accommodations[offer.packages[offerId].accommodations[0].id]
        let creativeFlightData = 'undefined'
        if (offer.packages[offerId].flights.length > 0) {
          creativeFlightData =
            offer.packages[offerId].flights[0].orig +
            '-' +
            offer.packages[offerId].flights[0].dest +
            ':' +
            offer.packages[offerId].flights[1].orig +
            '-' +
            offer.packages[offerId].flights[1].dest
        }
        window.dataLayer.push({
          event: 'promoClick',
          category: 'dealPromotion',
          action: 'conversion',
          label:
            'automated' +
            '|' +
            pagePostId +
            '|' +
            this.packageLists[0].config.adapter +
            '|package|' +
            offerId, // for example 'unifiedSearch|flight'
          ecommerce: {
            promoClick: {
              promotions: [
                {
                  id: offerId,
                  name:
                    'automated|' +
                    this.packageLists[0].config.adapter +
                    '|' +
                    pageType +
                    '|package|' +
                    hotelData.name, // for example 'unifiedSearch|flight'
                  creative:
                    hotelData.location.continent +
                    ':' +
                    hotelData.location.country +
                    ':' +
                    hotelData.location.city +
                    '|' +
                    creativeFlightData,
                  position: undefined
                }
              ]
            }
          }
        })
      } catch (err) {}
      this.tracked = true
    }
  }
}
</script>
